import {aiPromptBoxActions} from '@Components/ai-prompt-box/ai-prompt-box.reducer';
import type {AiChatControls} from '@Components/ai-chat-window/ai-chat-window.types';
import type {AiPromptBoxSelection} from '@Components/ai-prompt-box/components/ai-prompt-box-selection-chip/ai-prompt-box-selection-chip.types';
import type {AiChatControlHandlers} from './ai-chat-controls.library.types';

export function createAiChatControls({promptBoxId, sendMessage, stopTurn}: AiChatControlHandlers): AiChatControls {
  return {
    sendMessage,
    stopTurn,
    setSelections: (selections: AiPromptBoxSelection[]): void => {
      window.PMW.redux.store.dispatch(aiPromptBoxActions.setSelections({id: promptBoxId, selections}));
    },
  };
}
